import {
    mdiChartBar,
    mdiCashMultiple,
    mdiSourceBranch,
    mdiFileDocument,
    mdiCreditCardOutline,
    mdiPackageVariantClosed,
    mdiAccountBox,
    mdiAccount,
    mdiOfficeBuilding,
    mdiStar,
    mdiViewList,
    mdiGift,
    mdiTrophyVariant,
    mdiBullhorn,
    mdiFormatTitle,
    mdiCardBulletedOutline,
    mdiTicketPercent,
    mdiAtomVariant,
    mdiFinance
} from "@mdi/js";

import isEmpty from "lodash/isEmpty";
import {  mapActions } from "vuex";

export default {
    computed: {
        navLinks() {
            const { permissions, storePermissions, superUser } = this.$store.state

            let links = []
            if (!isEmpty(permissions) && !isEmpty(storePermissions) || superUser) {
                links = [
                        {
                            title: {
                                el: "",
                                en: "",
                                it: ""
                            },
                            children: [
                                {
                                    icon: mdiChartBar,
                                    title: {
                                        el: "Αρχική",
                                        en: "Home",
                                        it: "Iniziale"
                                    },
                                    to: `/${this.lang}/loyaltyPanel`,
                                    exact: true,
                                    hide: this.hideTitle('homepage?.read') 
                                }
                            ]
                        },
                        {
                            title: {
                                el: "ΟΝΤΟΤΗΤΕΣ",
                                en: "ENTITIES",
                                it: "ENTITA"
                            },
                            children: [
                                {
                                    icon: mdiSourceBranch,
                                    title: {
                                        el: "Καταστήματα",
                                        en: "Stores",
                                        it: "Stores"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/stores`,
                                    hide: this.hideTitle('stores.read')
                                },
                                {
                                    icon: mdiPackageVariantClosed,
                                    title: {
                                        el: "Προϊόντα",
                                        en: "Products",
                                        it: "Proddoti"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/products`,
                                    hide: this.hideTitle('products.read') 
                                },
                                {
                                    icon: mdiAccountBox,
                                    title: {
                                        el: "Πελάτες",
                                        en: "Customers",
                                        it: "Clienti"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/customers?page=1`,
                                    hide: this.hideTitle('customers.read')
                                },
                                {
                                    icon: mdiPackageVariantClosed,
                                    title: {
                                        el: "Προμηθευτές",
                                        en: "Suppliers",
                                        it: "Fornitori"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/supplier-management?page=1`,
                                    hide: this.hideTitle('gifts.read')
                                }
                            ]
                        },
                        {
                            title: {
                                el: "ΣΥΣΤΗΜΑ ΠΙΣΤΟΤΗΤΑΣ",
                                en: "LOYALTY SYSTEM",
                                it: "SISTEMA DI FEDELTÀ"
                            },
                            children: [
                                {
                                    icon: mdiFormatTitle,
                                    title: {
                                        el: "Επίπεδα",
                                        en: "Tiers",
                                        it: "Livelli"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/point-titles`,
                                    hide: this.hideTitle('point_packages.read') 
                                },
                                {
                                    icon: mdiCreditCardOutline,
                                    title: {
                                        el: "Πολλαπλά Κουπόνια",
                                        en: "Multiple Coupons",
                                        it: "Coupon multipli"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/multiple-coupons?page=1`,
                                    hide:  this.hideTitle('coupons.multiple.read') 
                                },
                                // {
                                //     icon: mdiTicketPercent,
                                //     title: {
                                //         el: "Κουπόνια Καταστημάτων",
                                //         en: "Store Coupons",
                                //         it: "Coupon del Negozio"
                                //     },
                                //     to: `/${this.lang}/loyaltyPanel/store-coupons?page=1`,
                                // },
                                {
                                    icon: mdiCardBulletedOutline,
                                    title: {
                                        el: "Κάρτες Πιστότητας",
                                        en: "Loyalty Cards",
                                        it: "Carte fedeltà"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/loyalty-cards`,
                                    hide: permissions.loyalty_cards && this.hideTitle('loyalty_cards.read') 
                                },
                                {
                                    icon: mdiTrophyVariant,
                                    title: {
                                        el: "Κατάλογος",
                                        en: "Catalog",
                                        it: "Catalogo"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/catalog`,
                                    hide: this.hideTitle('gifts.read') 
                                },
                                // {
                                //     icon: mdiViewList,
                                //     title: {
                                //         el: "Διαχείριση Κατηγοριών",
                                //         en: "Catalog Categories",
                                //         it: "Categorie del catalogo"
                                //     },
                                //     to: `/${this.lang}/loyaltyPanel/catalog-categories?page=1`,
                                //     hide: superUser || storePermissions.gift_categories?.read && permissions.gift_categories && permissions.gift_categories.read ? false : true
                                // },
                                {
                                    icon: mdiGift,
                                    title: {
                                        el: "Εξαργυρώσεις",
                                        en: "Redemptions",
                                        it: "Riscatti"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/redemptions`,
                                    hide: this.hideTitle('gift_categories.read')
                                },
                                {
                                    icon: mdiCreditCardOutline,
                                    title: {
                                        el: "Συνεργάτες",
                                        en: "Collaborators",
                                        it: "Collaboratori"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/collaborators?page=1`,
                                    hide: this.hideTitle('synergies?.read') 
                                },
                                {
                                    icon: mdiBullhorn,
                                    title: {
                                        el: "Καμπάνιες",
                                        en: "Campaigns",
                                        it: "Campagne"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/campaigns/view-campaigns?page=1`,
                                    hide: this.hideTitle('campaigns.read')
                                },
                                {
                                    icon: mdiAtomVariant,
                                    title: {
                                        el: "Προγράμματα Πιστότητας",
                                        en: "Loyalty Programs",
                                        it: "Programmi Φedeltà"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/loyalty-programs?page=1`,
                                    hide: this.hideTitle('loyalty.read')
                                },
                            ]
                        },
                        {
                            title: {
                                el: "ΔΙΑΧΕΙΡΙΣΗ",
                                en: "MANAGEMENT",
                                it: "GESTIONE"
                            },
                            children: [
                                {
                                    icon: mdiOfficeBuilding,
                                    title: {
                                        el: "Προφίλ",
                                        en: "Profile",
                                        it: "Profili"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/business-profile`,
                                    hide: this.hideTitle('profile.read') 
                                },
                                {
                                    icon: mdiFinance,
                                    title: {
                                        el: "Στατιστικά",
                                        en: "Statistics",
                                        it: "Statistiche"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/business-statistics?page=1`,
                                    hide: this.hideTitle('statistics.read')
                                },
                                {
                                    icon: mdiAccount,
                                    title: {
                                        el: "Χρήστες",
                                        en: "Users",
                                        it: "Utenti"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/user-rights?page=1`,
                                    hide: this.hideTitle('users.read') 
                                },
                                {
                                    icon: mdiCashMultiple,
                                    title: {
                                        el: "Οφειλές",
                                        en: "Debts",
                                        it: "Debiti"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/branch-debt`,
                                    hide: this.hideTitle('stores.debts.read')
                                },
                                // {
                                //     icon: mdiStar,
                                //     title: {
                                //         el: "Επιβράβευση",
                                //         en: "Reward",
                                //         it: "Ricompensa"
                                //     },
                                //     to: `/${this.lang}/loyaltyPanel/reward`,
                                // },
                                {
                                    icon: mdiFileDocument,
                                    title: {
                                        el: "Συνδρομές",
                                        en: "Subscriptions",
                                        it: "Abbonamenti"
                                    },
                                    to: `/${this.lang}/loyaltyPanel/subscriptions`,
                                    hide: this.hideTitle('subscriptions.stores') 
                                },
                            ]
                        },
                    



                        // {
                        //     title: {
                        //         el: "ΔΙΑΧΕΙΡΙΣΤΙΚΟ",
                        //         en: "MANAGE",
                        //         it: "GESTISCI"
                        //     },
                        //     children: [
                        //         {
                        //             icon: mdiChartBar,
                        //             title: {
                        //                 el: "Αρχική",
                        //                 en: "Home",
                        //                 it: "Iniziale"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel`,
                        //             exact: true,
                        //             hide: superUser || storePermissions.homepage?.read && permissions.homepage && permissions.homepage.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiCashMultiple,
                        //             title: {
                        //                 el: "Οφειλές Καταστημάτων",
                        //                 en: "Branch Debt",
                        //                 it: "Debito Della Filiale"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/branch-debt`,
                        //             hide: superUser || storePermissions.stores.debts?.read && permissions.stores.debts && permissions.stores.debts.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiSourceBranch,
                        //             title: {
                        //                 el: "Καταστήματα",
                        //                 en: "Stores",
                        //                 it: "Stores"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/stores`,
                        //             hide: superUser || storePermissions.stores?.read && permissions.stores && permissions.stores.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiFileDocument,
                        //             title: {
                        //                 el: "Συνδρομές",
                        //                 en: "Subscriptions",
                        //                 it: "Abbonamenti"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/subscriptions`,
                        //             hide: superUser || storePermissions.subscriptions?.stores && permissions.subscriptions && permissions.subscriptions.stores ? false : true
                        //         },
                        //         {
                        //             icon: mdiCreditCardOutline,
                        //             title: {
                        //                 el: "Συνεργάτες",
                        //                 en: "Collaborators",
                        //                 it: "Collaboratori"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/collaborators?page=1`,
                        //             hide: superUser || storePermissions.synergies?.read && permissions.synergies?.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiPackageVariantClosed,
                        //             title: {
                        //                 el: "Προϊόντα",
                        //                 en: "Products",
                        //                 it: "Proddoti"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/products`,
                        //             hide: superUser || storePermissions.products?.read && permissions.products && permissions.products.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiAccountBox,
                        //             title: {
                        //                 el: "Πελάτες",
                        //                 en: "Customers",
                        //                 it: "Clienti"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/customers?page=1`,
                        //             hide: superUser || storePermissions.customers?.read && permissions.customers && permissions.customers.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiAccount,
                        //             title: {
                        //                 el: "Δικαιώματα χρηστών",
                        //                 en: "User Rights",
                        //                 it: "Diritti dell'utente"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/user-rights?page=1`,
                        //             hide: superUser || storePermissions.users?.read && permissions.users && permissions.users.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiOfficeBuilding,
                        //             title: {
                        //                 el: "Προφιλ επιχείρησης",
                        //                 en: "Business Profile",
                        //                 it: "Profilo Aziendale"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/business-profile`,
                        //             hide: superUser || storePermissions.profile?.read && permissions.profile && permissions.profile.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiFinance,
                        //             title: {
                        //                 el: "Στατιστικά Επιχείρησης",
                        //                 en: "Business Statistics",
                        //                 it: "Statistiche aziendali"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/business-statistics?page=1`,
                        //             hide: superUser || storePermissions.statistics?.read && permissions.statistics && permissions.statistics.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiCreditCardOutline,
                        //             title: {
                        //                 el: "Πολλαπλά Κουπόνια",
                        //                 en: "Multiple Coupons",
                        //                 it: "Coupon multipli"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/multiple-coupons?page=1`,
                        //             hide: superUser || storePermissions.coupons?.multiple.read && permissions.coupons.multiple && permissions.coupons.multiple.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiFormatTitle,
                        //             title: {
                        //                 el: "Πακέτα Πόντων",
                        //                 en: "Point Packages",
                        //                 it: "Pacchetti di punti"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/point-titles`,
                        //             hide: superUser || storePermissions.point_packages?.read && permissions.point_packages && permissions.point_packages.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiCardBulletedOutline,
                        //             title: {
                        //                 el: "Κάρτες Πιστότητας",
                        //                 en: "Loyalty Cards",
                        //                 it: "Carte fedeltà"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/loyalty-cards`,
                        //             hide: superUser || storePermissions.loyalty_cards?.read && permissions.loyalty_cards && permissions.loyalty_cards.read ? false : true
                        //         }
                        //     ]
                        // },
                        // {
                        //     title: {
                        //         el: "ΔΩΡΑ",
                        //         en: "GIFTS",
                        //         it: "REGALI"
                        //     },
                        //     children: [
                        //         {
                        //             icon: mdiViewList,
                        //             title: {
                        //                 el: "Διαχείριση Κατηγοριών",
                        //                 en: "Catalog Categories",
                        //                 it: "Categorie del catalogo"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/catalog-categories?page=1`,
                        //             hide: superUser || storePermissions.gift_categories?.read && permissions.gift_categories && permissions.gift_categories.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiGift,
                        //             title: {
                        //                 el: "Κατάσταση Δώρων",
                        //                 en: "Gift Status",
                        //                 it: "Stato dei regali"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/gift-status`,
                        //             hide: superUser || storePermissions.gift_categories?.read && permissions.gift_categories && permissions.gift_categories.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiTrophyVariant,
                        //             title: {
                        //                 el: "Διαχείριση Καταλόγου",
                        //                 en: "Gift Catalog",
                        //                 it: "Catalogo dei regali"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/gift-catalog?page=1`,
                        //             hide: superUser || storePermissions.gifts?.read && permissions.gifts && permissions.gifts.read ? false : true
                        //         },
                        //         {
                        //             icon: mdiPackageVariantClosed,
                        //             title: {
                        //                 el: "Διαχείριση Προμηθευτών",
                        //                 en: "Supplier Management",
                        //                 it: "Gestione dei fornitori"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/supplier-management?page=1`,
                        //             hide: superUser || storePermissions.gifts?.read && permissions.gifts && permissions.gifts.read ? false : true
                        //         }
                        //     ]
                        // },
                        // {
                        //     title: {
                        //         el: "ΠΡΟΣΕΛΚΥΣΕ ΠΕΛΑΤΕΣ",
                        //         en: "ATTRACT CUSTOMERS",
                        //         it: "ATTIRARE I CLIENTI"
                        //     },
                        //     children: [
                        //         {
                        //             icon: mdiBullhorn,
                        //             title: {
                        //                 el: "Καμπάνιες",
                        //                 en: "View Campaigns",
                        //                 it: "Campagne"
                        //             },
                        //             to: `/${this.lang}/loyaltyPanel/view-campaigns?page=1`,
                        //             hide: superUser || storePermissions.campaigns?.read && permissions.campaigns && permissions.campaigns.read ? false : true
                        //         },
                        //     ]
                        // }
                    ];
            }
            return links
        }
    },
    methods: {
        ...mapActions(["getPermission"]),
        hideTitle(permission){
            return !(this.getPermission(permission))
        }
        
    },
    
};
